import { SystemMessage } from "@app/constants";
import * as Yup from "yup";

export const createUserValidationSchema = Yup.object().shape({
  fullName: Yup.string().required(SystemMessage.INPUT_REQUIRED),
  username: Yup.string().required(SystemMessage.INPUT_REQUIRED),
  password: Yup.string().required(SystemMessage.INPUT_REQUIRED),
});
